import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@mui/material';
import cn from 'classnames';

type EllipsisTextProps = {
  text: string;
  width?: string;
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
  disableTooltip?: boolean;
};

export const TextContainer = styled.div<{
  width: EllipsisTextProps['width'];
}>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: ${({ width }) => width || 'unset'};
`;

const EllipsisText: React.FC<EllipsisTextProps> = ({
  text,
  width,
  style = {},
  className = '',
  children,
  disableTooltip = false,
}) => {
  const content = (
    <TextContainer width={width} style={style} className={cn(className, { 'ellipsis-text': true })}>
      {children}
    </TextContainer>
  );

  if (disableTooltip) return content;
  return (
    <Tooltip title={text || ''} placement="top">
      {content}
    </Tooltip>
  );
};

export default EllipsisText;
